/* Wishlist reminder bridge + "email me a reminder" prompt (2026-09-19).

   Listens to wishlist.js's own `wishlist:change` event. For an IN-STOCK save:
   - shopper already identified (email/phone given before, or Omnisend cookie)
     -> tell the restock Worker, which sends Omnisend `wishlist saved item`.
     That event drives the 6h reminder + 1 day SAVE5 automation.
   - shopper unknown -> offer a small, optional "email me a reminder" card.
     Submitting subscribes that email (explicit consent line) and sends the
     same event. Dismissing hides the card for 7 days.
   Sold-out saves are skipped: they go through the restock dialog instead.

   ponytail: separate file so wishlist.js stays untouched; delete this file and
   its tag in layout/theme.liquid to remove the feature. */
(function () {
  'use strict';
  var ENDPOINT = 'https://cgs-restock-notify.amraliwoow.workers.dev/wishlist';
  var EMAIL_KEY = 'cgs_wl_email';
  var OFF_KEY = 'cgs_wl_prompt_off';
  var WEEK = 7 * 24 * 3600 * 1000;

  var AR = (document.documentElement.lang || '').slice(0, 2) === 'ar';
  var T = AR ? {
    title: 'عايز نفكّرك؟',
    sub: 'هنبعتلك إيميل لو لسه بتفكّر فيه — وممكن معاه خصم.',
    placeholder: 'الإيميل',
    button: 'فكّرني',
    consent: 'بالضغط توافق على استلام إيميلات من Coffee Gamer Store. تقدر تلغي في أي وقت.',
    bad: 'اكتب إيميل صحيح.',
    done: 'تمام — هنفكّرك.',
    close: 'إغلاق'
  } : {
    title: 'Want a reminder?',
    sub: 'We will email you if it is still waiting in your wishlist - maybe with a little discount.',
    placeholder: 'Your email',
    button: 'Remind me',
    consent: 'By tapping Remind me you agree to receive emails from Coffee Gamer Store. Unsubscribe anytime.',
    bad: 'Enter a valid email.',
    done: 'Done - we will remind you.',
    close: 'Close'
  };

  function ls(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key) || '';
      localStorage.setItem(key, value);
    } catch (e) { /* private mode */ }
    return '';
  }
  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function welcomePhone() {
    try { return JSON.parse(ls('cgs_welcome_offer_v1') || '{}').phone || ''; } catch (e) { return ''; }
  }
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function send(item, who, subscribe) {
    var image = item.image && item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image;
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        phone: who.phone || '',
        email: who.email || '',
        contactID: who.contactID || '',
        subscribe: !!subscribe,
        productId: item.id,
        title: item.title,
        url: location.origin + item.url,
        image: image,
        price: Number(item.price || 0),
        source: item.source || 'product'
      })
    });
  }

  /* ---------- prompt ---------- */

  var CSS =
    '.wlr{position:fixed;z-index:2147483000;inset-inline:16px;bottom:calc(16px + env(safe-area-inset-bottom));' +
    'max-width:400px;margin-inline:auto;padding:18px 18px 14px;border-radius:20px;color:#111;' +
    'background:rgba(255,255,255,.86);-webkit-backdrop-filter:blur(24px) saturate(1.6);backdrop-filter:blur(24px) saturate(1.6);' +
    'border:1px solid rgba(0,0,0,.08);box-shadow:0 18px 50px rgba(0,0,0,.18);font:inherit;' +
    'transform:translateY(12px);opacity:0;transition:transform .28s ease,opacity .28s ease}' +
    '.wlr.is-in{transform:none;opacity:1}' +
    '.wlr__x{position:absolute;inset-inline-end:8px;top:8px;width:36px;height:36px;border:0;background:none;' +
    'font-size:22px;line-height:1;color:#666;cursor:pointer;border-radius:50%}' +
    '.wlr__t{margin:0 40px 4px 0;font-size:16px;font-weight:700}' +
    '[dir=rtl] .wlr__t{margin:0 0 4px 40px}' +
    '.wlr__s{margin:0 0 12px;font-size:13px;line-height:1.45;color:#555}' +
    '.wlr__row{display:flex;gap:8px}' +
    '.wlr__in{flex:1;min-width:0;height:46px;padding:0 14px;border-radius:12px;border:1px solid rgba(0,0,0,.18);' +
    'background:#fff;font-size:16px;color:#111}' +
    '.wlr__in[aria-invalid=true]{border-color:#c62828}' +
    '.wlr__b{height:46px;padding:0 18px;border:0;border-radius:12px;background:#111;color:#fff;font-size:15px;' +
    'font-weight:700;cursor:pointer;white-space:nowrap}' +
    '.wlr__b[disabled]{opacity:.6}' +
    '.wlr__c{margin:10px 0 0;font-size:11px;line-height:1.4;color:#777}' +
    '.wlr__e{margin:8px 0 0;font-size:12px;color:#c62828}' +
    '.wlr__e[hidden]{display:none}' +
    '@media (prefers-reduced-motion:reduce){.wlr{transition:none}}';

  var open = null;

  function showPrompt(item) {
    if (open) open.close(false);
    if (!document.getElementById('wlr-css')) {
      var st = document.createElement('style');
      st.id = 'wlr-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    /* The card already confirms the save; the engine's own toast would sit
       underneath it. */
    var toast = document.querySelector('.wl-toast');
    if (toast) toast.remove();

    var uid = 'wlr-' + Date.now();
    var el = document.createElement('div');
    el.className = 'wlr';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-labelledby', uid + '-t');
    el.innerHTML =
      '<button type="button" class="wlr__x" aria-label="' + T.close + '">&times;</button>' +
      '<p class="wlr__t" id="' + uid + '-t">' + T.title + '</p>' +
      '<p class="wlr__s">' + T.sub + '</p>' +
      '<form class="wlr__row" novalidate>' +
        '<label class="visually-hidden" for="' + uid + '-e" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">' + T.placeholder + '</label>' +
        '<input class="wlr__in" id="' + uid + '-e" type="email" inputmode="email" autocomplete="email" placeholder="' + T.placeholder + '">' +
        '<button class="wlr__b" type="submit">' + T.button + '</button>' +
      '</form>' +
      '<p class="wlr__e" role="alert" hidden></p>' +
      '<p class="wlr__c">' + T.consent + '</p>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    var input = el.querySelector('.wlr__in');
    var btn = el.querySelector('.wlr__b');
    var err = el.querySelector('.wlr__e');

    function close(dismissed) {
      document.removeEventListener('keydown', onKey);
      if (dismissed) ls(OFF_KEY, String(Date.now()));
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); }, 300);
      open = null;
    }
    function onKey(e) { if (e.key === 'Escape') close(true); }
    document.addEventListener('keydown', onKey);
    el.querySelector('.wlr__x').addEventListener('click', function () { close(true); });

    el.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim().toLowerCase();
      if (!validEmail(email)) {
        err.textContent = T.bad;
        err.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      btn.disabled = true;
      ls(EMAIL_KEY, email);
      send(item, { email: email }, true).catch(function () {});
      el.querySelector('.wlr__s').textContent = T.done;
      el.querySelector('form').hidden = true;
      el.querySelector('.wlr__c').hidden = true;
      err.hidden = true;
      setTimeout(function () { close(false); }, 2200);
    });

    open = { close: close };
  }

  /* ---------- wiring ---------- */

  document.addEventListener('wishlist:change', function (e) {
    var d = e.detail || {};
    var item = d.item;
    if (!d.added || !item || !item.id || item.available === false) return;

    var who = {
      phone: ls('cgs_wl_phone') || welcomePhone(),
      email: ls(EMAIL_KEY),
      contactID: cookie('omnisendContactID')
    };
    try {
      if (who.phone || who.email || who.contactID) {
        send(item, who, false).catch(function () {});
        return;
      }
      var off = Number(ls(OFF_KEY)) || 0;
      if (Date.now() - off < WEEK) return;
      /* After the engine's click handler has shown its toast. */
      setTimeout(function () { showPrompt(item); }, 50);
    } catch (err) { /* a reminder must never break the save */ }
  });
})();
